const basePath = '/assets/fruit-fiesta-assets/'
const commonPath = '/assets/common/';

export const path = {
  imagePath: basePath + 'images/',
  spriteSheetsPath: basePath + 'spriteSheets/',
  spine: basePath + 'spine/',
  sound: basePath + 'sounds/',
  font : basePath + 'fonts/',
  translations: basePath + 'translations/',
  victoryPath: commonPath + 'sounds/',
  spriteSheetCommon: commonPath + 'spriteSheets/',

}

export const settings = {
    originalWidth: 1920,
    originalHeight: 1080,
    backgroundColor: 0xFF0000,
    backgroundAlpha: 1,
    devicePixelRatio: window.devicePixelRatio || 1,
    div: () => document.getElementById('pixi-game')
  }